import React from 'react'

const IconRecycling = props => (
  <svg viewBox="0 0 20 20" {...props}>
    <path
      fill="#09C5B8"
      d="M14.7 12.8H9.9v3.4h4c.5 0 .9-.3 1.2-.7l.6-1-1-1.7zm-7-4.2L4.8 6.9l-2 3.5c-.2.4-.2.9 0 1.4l.6 1h2l2.3-4.2zm2.3-4l2.4 4.1 3-1.7-2-3.5c-.2-.4-.7-.7-1.2-.7H11l-1 1.8z"
    />
    <path
      fill="#28D88C"
      d="M8.8 11.9c-.2 0-.4.2-.4.4v.5H3.3L5 15.7c.2.3.5.5.8.5h2.6v.6c0 .2.2.4.4.4.1 0 .2 0 .3-.1l2.3-2.3c.1-.1.1-.4 0-.5L10 12.9l-.9-.9c-.1-.1-.2-.1-.3-.1zm.3-3.8c.1-.1 0-.4-.2-.5l-.4-.2L10 4.6l1-1.7H7.9c-.5 0-.9.3-1.2.7l-1.2 2-.5-.2c-.2-.1-.4 0-.5.1 0 .1-.1.2 0 .3l.3 1.1.5 2c.1.2.3.3.5.3l3.1-.8c0-.1.1-.2.2-.3zm7 .3l.5-.3c.2-.1.2-.3.1-.5 0-.1-.1-.1-.2-.2l-3.1-.8c-.2-.1-.4.1-.5.3l-.8 3v.3c.1.2.3.2.5.1l.5-.3 1.6 2.7 1 1.7 1.6-2.7c.2-.4.2-.9 0-1.4l-1.2-1.9z"
    />
  </svg>
);

export default IconRecycling



// WEBPACK FOOTER //
// ./src/components/SVG/Navbar/IconRecycling.js